import {CURSOR_MARK, MarkedInput, Options} from './types';
import getWhitelistedKeys from './getWhitelistedKeys';
import {isSeparator, isMark, isSign} from './helpers';

const isPrefixed = (input: MarkedInput, prefix: string): boolean => {
  const part = input.slice(0, prefix.length);
  return !part.includes(CURSOR_MARK) && part.join('') === prefix;
}

const isSuffixed = (input: MarkedInput, suffix: string): boolean => {
  const part = input.slice(input.length - suffix.length);
  return !part.includes(CURSOR_MARK) && part.join('') === suffix;
}

const sanitize = (input: MarkedInput, signed: boolean, separatorPressed: boolean, options: Options): MarkedInput => {
  const {groupSeparator, prefix, suffix, radix} = options;
  /* 'real' group separators are already removed before change */
  const whitelistedKeys = getWhitelistedKeys(signed, options);
  let cleaned = input;
  if (isPrefixed(input, prefix)) {
    cleaned = cleaned.slice(prefix.length);
  }
  if (isSuffixed(cleaned, suffix)) {
    cleaned = cleaned.slice(0, cleaned.length - suffix.length);
  }
  cleaned = cleaned
    .filter(char => isMark(char) || whitelistedKeys.includes(char))
    .filter(char => !isSign(char))
    .filter(char => char !== groupSeparator);

  return !separatorPressed ? cleaned : cleaned
    .filter(char => !isSeparator(char))
    .reduce((cleaned, char) => isMark(char) ? [...cleaned, radix, char] : [...cleaned, char], []);
}

export default sanitize;
